// @flow

import * as React from 'react';
import {useAnalytics} from 'docs/data';
import './Button.scss';

type ButtonProps = {|
  type: 'button' | 'link',
  href?: string,
  analytics?: Object,
  children?: React.Node,
|};

// We render our own button instead of using the relevant sail component because
// the sail button uses div containers that cannot be nested inside of a "p" tag.
// We temporarily removed the "icon" attribute because it relied on sail and needs
// to be replaced with a non-sail equivalent. - rpaul

export const DocsButton = ({type, href, analytics, children}: ButtonProps) => {
  const {trackAction} = useAnalytics();

  const handleClick = () => {
    if (analytics) {
      trackAction(analytics.action, {
        source: analytics.source,
      });
    }
  };

  return (
    <a
      href={href}
      className={type === 'button' ? 'MarkdocButton' : ''}
      onClick={handleClick}
    >
      {children}
    </a>
  );
};
